import { render, staticRenderFns } from "./MyDashBoard.vue?vue&type=template&id=5c46e0c9&scoped=true"
import script from "./MyDashBoard.vue?vue&type=script&lang=js"
export * from "./MyDashBoard.vue?vue&type=script&lang=js"
import style0 from "./MyDashBoard.vue?vue&type=style&index=0&id=5c46e0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46e0c9",
  null
  
)

export default component.exports